module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Clipboard-check-bbad78f1b2622734355fdbc055ef7480.svg";